// auth.js

export default function auth({ next }) {
  if (!localStorage.getItem('jwt-token')) {
      return next({ name: 'Login' });
  }else{
      return next();
  }
}